import LocalizeNamespaces from 'shared/constants/localize-namespaces.mjs'

export enum TimeType {
  DAYS = 'day',
  HOURS = 'hour',
  MINUTES = 'minute',
}

export enum TimeTypeState {
  before = 'before',
  after = 'after',
}

export const TIME_LABELS: Record<TimeType, string> = {
  [TimeType.DAYS]: 'global.name_of_times.day_icu',
  [TimeType.HOURS]: 'global.name_of_times.hour_icu',
  [TimeType.MINUTES]: 'global.name_of_times.minutes_icu',
}

export const TIME_WITH_COUNT_LABELS: Record<TimeType, string> = {
  [TimeType.DAYS]: 'global.name_of_times.day_with_count_icu',
  [TimeType.HOURS]: 'global.name_of_times.hour_with_count_icu',
  [TimeType.MINUTES]: 'global.name_of_times.minutes_with_count_icu',
}

export const TimeDelayPickerLoco = [LocalizeNamespaces.name_of_times]
